import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetInvitationOutput, InvitationsListInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/** `GET /v1/invitation` — les invitations non encore acceptées du compte. */
export const useInvitations = (input: InvitationsListInput) =>
  useQuery<ListOutput<ExtranetInvitationOutput>>({
    queryKey: extranetQueryKeys.invitations.list(input),
    queryFn: () =>
      getExtranetApi().get<InvitationsListInput, ListOutput<ExtranetInvitationOutput>>('/v1/invitation', input),
    placeholderData: keepPreviousData,
  });
